class SdGuide {
	constructor() {
		this.line = document.querySelector( '.big-number-steps__line' );
		this.numbers = [].slice.call( document.querySelectorAll( '.big-number-step__number' ) );
		this.numbersTop = 0;
		this.numberHeight = 0;
		this.centerThreshold = 0;
		
		this.calcNumberHeight();
		this.calcCenterThreshold();
		this.animateNumbers();
		this.dispatchEvents();
	}
	
	dispatchEvents() {
		window.addEventListener( 'scroll', () => {
			this.animateLine();
			this.animateNumbers();
			this.calcMaxLineHeight();
		} );
		window.addEventListener( 'resize', () => {
			this.calcNumberHeight();
			this.calcCenterThreshold();
		} );
	}
	
	animateLine() {
		const boundingBox = this.line.getBoundingClientRect();
		let height = 0;
		if ( this.numbersTop ) {
			height = ( boundingBox.top * -1 ) + this.numbersTop;
		} else {
			height = ( boundingBox.top * -1 ) + window.innerHeight;
		}
		this.line.style.height = `${ height }px`;
		
	}
	
	animateNumbers() {
		this.numbers.forEach( number => {
			const image = number.querySelector( 'img' );
			const bound = image.getBoundingClientRect();
			
			if ( bound.bottom < window.innerHeight ) {
				number.classList.add( 'reveal' );
			}
			if ( bound.top < this.centerThreshold ) {
				number.classList.add( 'past-center' );
				this.numbersTop = 0;
			}
		} );
	}
	
	calcMaxLineHeight() {
		this.numbers.forEach( number => {
			const bound = number.getBoundingClientRect();
			if ( bound.top < window.innerHeight && !number.classList.contains( 'past-center' ) ) {
				if ( number.classList.contains( 'reveal' ) ) {
					this.numbersTop = bound.top + this.numberHeight;
				} else {
					this.numbersTop = bound.top;
				}
			}
		} );
	}
	
	calcNumberHeight() {
		this.numberHeight = this.numbers[ 0 ].querySelector( 'img' ).clientHeight;
	}
	
	calcCenterThreshold() {
		this.centerThreshold = ( window.innerHeight - this.numberHeight ) * 0.2;
	}
}

export default SdGuide;
